import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  phone: string;
  type: 'text' | 'template';
  /** Required for a text reply. */
  body?: string;
  /** Required for a template reply. */
  template_name?: string;
  language_code?: string;
  /** Leave unset to reply from the number the customer last wrote to. */
  from_number?: string;
};

type MutationResponse = {
  status: number;
  data: Record<string, unknown>;
};

export const useReplyConversationMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while sending the reply',
    endpoint: ({ phone }) => `/api/admin/whatsapp/conversation/${encodeURIComponent(phone)}/reply`,
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
